import { result } from 'lodash';

let ApiUrls = [];
ApiUrls['sparedox-test.web.app'] = 'https://sparedox.azurewebsites.net/';
ApiUrls['sparedoxdev.web.app'] = 'https://sparedoxdev.azurewebsites.net/';
ApiUrls['sparedox.ozonemarine.in'] =
    'https://sparedox-prod1.azurewebsites.net/';

let baseUrl =
    process.env.NODE_ENV == 'development'
        ? 'http://localhost:65010/'
        : ApiUrls[location.hostname] ||
          'https://sparedoxdev.azurewebsites.net/';

function _getFullUrl(url) {
    return new URL(url, baseUrl).toString();
}

function get(url, prop) {
    try {
        return fetch(_getFullUrl(url), prop);
    } catch (error) {
        alert('Api server not reachable.');
        return;
    }
}

function getJSON(url) {
    var myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    myHeaders.append('Accept', 'application/json');
    let token = localStorage.getItem('_auth');
    myHeaders.append('Authorization', `Bearer ${token}`);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(_getFullUrl(url), requestOptions)
        .then((response: Response) => response.text())
        .then((text: string) => (text ? JSON.parse(text) : null));
}

function postJSON(url: string, param) {
    var myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    myHeaders.append('Accept', 'application/json');
    let token = localStorage.getItem('_auth');
    myHeaders.append('Authorization', `Bearer ${token}`);

    var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: JSON.stringify(param),
        redirect: 'follow'
    };

    return fetch(_getFullUrl(url), requestOptions)
        .then((response: Response) => response.text())
        .then((text: string) => (text ? JSON.parse(text) : null));
}

function putJSON(url: string, param) {
    var myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    myHeaders.append('Accept', 'application/json');
    let token = localStorage.getItem('_auth');
    myHeaders.append('Authorization', `Bearer ${token}`);

    var requestOptions = {
        method: 'PUT',
        headers: myHeaders,
        body: JSON.stringify(param),
        redirect: 'follow'
    };

    return fetch(_getFullUrl(url), requestOptions)
        .then((response: Response) => response.text())
        .then((text: string) => (text ? JSON.parse(text) : null));
}

function deleteJSON(url: string, param) {
    var myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    myHeaders.append('Accept', 'application/json');
    let token = localStorage.getItem('_auth');
    myHeaders.append('Authorization', `Bearer ${token}`);

    var requestOptions = {
        method: 'DELETE',
        headers: myHeaders,
        body: JSON.stringify(param),
        redirect: 'follow'
    };

    return fetch(_getFullUrl(url), requestOptions)
        .then((response: Response) => response.text())
        .then((text: string) => (text ? JSON.parse(text) : null));
}

export { getJSON, postJSON, putJSON, deleteJSON, get, baseUrl };



// WEBPACK FOOTER //
// ./demo/src/RestHandler.js